import { useEffect, useState } from 'react';

/**
 * Hook that returns true only after the component has hydrated on the client side.
 * Useful for preventing SSR hydration mismatches when client-only logic is needed.
 */
export const useIsHydrated = (): {
  isHydrated: boolean;
} => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return { isHydrated };
};
